import { render, staticRenderFns } from "./MoodleCoursesProgressChart.vue?vue&type=template&id=503eba6a"
import script from "./MoodleCoursesProgressChart.vue?vue&type=script&lang=js"
export * from "./MoodleCoursesProgressChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports